<template>
  <mdb-container v-if="docData.content">
    <banner :group="docData.group"/>
    <mdb-row>
      <mdb-col class="text-left" md="12">
        <mdb-card class="text-left">
          <mdb-card-header>
            {{docData.content.title}}
          </mdb-card-header>
          <mdb-card-body>
            <user-content :content="docData.content.html" id="document-data"/>
          </mdb-card-body>
        </mdb-card>
      </mdb-col>
    </mdb-row>
  </mdb-container>
</template>

<script>
  import api from '../../services/groupsPlaceApi.js'
  import {mdbCard, mdbCardBody, mdbCardHeader, mdbCardText, mdbCardTitle, mdbCol, mdbContainer, mdbRow} from 'mdbvue';
  import Banner from "./Banner"
  import UserContent from "../common/UserContent";

  export default {
        name: 'Documents',
        components: {
            Banner,
            mdbContainer,
            mdbCard,
            mdbCardHeader,
            mdbCardBody,
            mdbCardTitle,
            mdbCardText,
            mdbRow,
            mdbCol,
            UserContent
        },
        data() {
            return {
                docData: {}
            }
        },
        mounted() {
            this.loadPage()
        },
        methods: {
            loadPage: async function () {
                this.refreshing = true
                let details = await api.get("/group/content/" + this.$route.params.groupId + "?doc=" + this.$route.params.documentId, {});
                if (details.status == 200) {
                    this.docData = details.data
                    document.title = details.data.content.title
                } else if (details.status == 403) {
                  await this.$router.push({path: '/403', query: { redirect: this.$route.fullPath}})
                  return
                } else this.errorMessage = details.data
                this.refreshing = false;
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  @media screen and (max-width: 749px ) {
    .group-overlay-container {
      font-size: 175%;
      width: 84%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-right: 1.75em;
    }
  }

  @media screen and (min-width: 750px ) {
    .group-overlay-container {
      font-size: 250%;
      margin-left: 2.5em;
      margin-bottom: 30px;
    }

  }

  .group-banner {
    display: block;
    width: 100%;
    background-size: cover;
    padding-top: 25%;
    position: relative;
  }

  .group-overlay-container {
    background-color: #ffffff;
    opacity: 0.8;
    position: absolute;
    bottom: 0;
    padding-left: 10px;
    padding-right: 10px;
  }

  .group-overlay-name a {
    color: #362f2d;
    opacity: 1;
  }


</style>
